import Api from "../api/EmailAuthenticationApi";
import * as types from "./ActionTypes";
import * as Constants from "../utilities/Constants";
import UrlHelper from "../utilities/UrlHelper";
import CookieManager from "../utilities/CookieManager";
import AuthenticationType from "../configurations/AuthenticationType";
import OperationsHelper from "newApp/utilities/OperationsHelper";

export const sendVerifyEmail = (id, email) => {
    return (dispatch) => {
        return Api.sendVerifyEmail(id, email)
            .then(() => {
                dispatch({ type: types.SEND_VERIFY_EMAIL_SUCCEEDED, currentStep: Constants.linkEmailSteps.second, email:email });
            })
            .catch((error) => {
                dispatch({ type: types.SEND_VERIFY_EMAIL_FAILED, error, currentStep: Constants.linkEmailSteps.first });
                // throw(error);
            });
    };
};

export const startUpgradeToVirtualUser = (email) => {
    return (dispatch) => {
        return Api.loginByEmailForVirtualUserUpgrade(email)
            .then((user) => {
                if (user.AuthenticationType === AuthenticationType.Sso.value)
                    dispatch({ type: types.LINK_TO_VIRTUAL_USER_SUCCEEDED, redirectLocation: UrlHelper.getCompleteExternalLoginUrl(user.ExternalLoginUrl) });
                else
                    dispatch({ type: types.GO_TO_LINK_USER_TO_VIRTUAL_USER });
            })
            .catch(() => {
                return dispatch(sendEmailOnUpgradeToVirtualUser(email));
            });
    };
};

const sendEmailOnUpgradeToVirtualUser = (email) => {
    return (dispatch) => {
        return Api.sendEmailOnUpgradeToVirtualUser(email)
            .then(() => {
                dispatch({ type: types.SEND_VERIFY_EMAIL_SUCCEEDED, currentStep: Constants.linkEmailSteps.second, email:email });
            })
            .catch((error) => {
                dispatch({ type: types.SEND_VERIFY_EMAIL_FAILED, error, currentStep: Constants.linkEmailSteps.first });
            });
    };
};

export const goToTheFirstLinkingEmailStep = () =>{
    return ({ type: types.VERIFY_EMAIL_GO_TO_FIRST_STEP });
};

export const startLoginByEmail = (email) => {
    return (dispatch) => {
        return Api.loginByEmail(email)
            .then((settings) => {
                dispatch({ type: types.LOGIN_BY_EMAIL_SUCCEEDED, settings: settings, email: email });
            })
            .catch(error => {
                dispatch({ type: types.LOGIN_BY_EMAIL_FAILED, error });
                // throw(error);
            });
    };
};

export const backToEmailForm = () => {
    return { type: types.BACK_TO_EMAIL_FORM };
};

export const backToPasswordForm = () => {
    return { type: types.BACK_TO_PASSWORD_FORM };
};

export const backToResendEmail = () =>{
    return ({ type: types.BACK_TO_SEND_VERIFY_EMAIL_FORM });
};

export const goToPasswordReset = () =>{
    return ({ type: types.START_RESET_PASSWORD_SUCCEEDED });
};

export const completeEmailLogin = (email, password, productCode, returnUrl) => {
    return (dispatch) => {
        return Api.completeEmailLogin(email, password, productCode, returnUrl)
            .then((response) => {
                dispatch({ type: types.COMPLETE_LOGIN_BY_EMAIL_SUCCEEDED, redirectTo: response.Url });
            })
            .catch((error) => {
                dispatch({ type: types.COMPLETE_LOGIN_BY_EMAIL_FAILED, error });
                //  throw(error);
            });
    };
};

export const sendResetPasswordLink = (email) => {
    return (dispatch) => {
        return Api.sendResetPasswordLink(email)
            .then(() => {
                dispatch({ type: types.START_RESET_PASSWORD_SUCCEEDED });
            })
            .catch((error) => {
                dispatch({ type: types.START_RESET_PASSWORD_FAILED, error });
                throw (error);
            });
    };
};

export const resendResetPasswordLink = (email) => {
    return (dispatch) => {
        dispatch({ type: types.RESEND_START_RESET_PASSWORD });

        return dispatch(sendResetPasswordLink(email))
            .finally(()=>OperationsHelper.delay(() => dispatch({ type: types.RESEND_START_RESET_PASSWORD_DEBOUNCE_FINISHED }), 3000));
    };
};

export const getTicketExpirationPeriod = (isVirtualUser, ticketType) => {
    return (dispatch) => {
        return Api.getTicketExpirationPeriod(isVirtualUser, ticketType)
            .then((response) => {
                dispatch({ type: types.GET_TICKET_EXPIRATION_PERIOD_SUCCEEDED, expirationPeriod: response });
            })
            .catch((error) => {
                dispatch({ type: types.GET_TICKET_EXPIRATION_PERIOD_FAILED, error });
                throw(error);
            });
    };
};

export const setPassword = (ticket, pin, password) => {
    return (dispatch) => {
        dispatch({ type: types.SET_RESET_PASSWORD_STARTED });
        return Api.setPassword(ticket, pin, password)
            .then((response) => {
                dispatch({ type: types.SET_PASSWORD_SUCCEEDED, url: response.Url });
            })
            .catch((error) => {
                dispatch({ type: types.SET_PASSWORD_FAILED, error });
                throw(error);
            });
    };
};

export const resetPassword = (ticket, password) => {
    return (dispatch) => {
        dispatch({ type: types.SET_RESET_PASSWORD_STARTED });
        return Api.resetPassword(ticket, password)
            .then((response) => {
                dispatch({ type: types.RESET_VIRTUAL_USER_PASSWORD_SUCCEEDED, url: response.Url });
            })
            .catch((error) => {
                dispatch({ type: types.RESET_VIRTUAL_USER_PASSWORD_FAILED, error });
                throw(error);
            });
    };
};

export const upgradeToVirtualUser = (ticket, password) => {
    return (dispatch) => {
        dispatch({ type: types.SET_RESET_PASSWORD_STARTED });
        return Api.upgradeToVirtualUser(ticket, password)
            .then((response) => {
                dispatch({ type: types.UPGRADE_TO_VIRTUAL_USER_SUCCEEDED, url: response.Url });
            })
            .catch((error) => {
                dispatch({ type: types.UPGRADE_TO_VIRTUAL_USER_FAILED, error });
                throw(error);
            });
    };
};

export const linkToVirtualUser = (email, password) => {
    return (dispatch) => {
        return Api.linkToVirtualUser(email, password)
            .then((response) => {
                dispatch({ type: types.LINK_TO_VIRTUAL_USER_SUCCEEDED, redirectLocation: response.Url });
            })
            .catch((error) => {
                dispatch({ type: types.LINK_TO_VIRTUAL_USER_FAILED, error });
                throw(error);
            });
    };
};

export const validateUserTicket = (ticket, type) => {
    return (dispatch) => {
        return Api.validateUserTicket(ticket, type)
            .then((response) => {
                dispatch({ type: types.VALIDATE_TICKET_SUCCEEDED, response });
            })
            .catch((error) => {
                dispatch({ type: types.VALIDATE_TICKET_FAILED, error });
                throw(error);
            });
    };
};

export const validateVirtualUserTicket = (ticket, type) => {
    return (dispatch) => {
        return Api.validateVirtualUserTicket(ticket, type)
            .then((response) => {
                dispatch({ type: types.VALIDATE_TICKET_SUCCEEDED, response });
            })
            .catch((error) => {
                dispatch({ type: types.VALIDATE_TICKET_FAILED, error });
                throw(error);
            });
    };
};

export const setEmail = (ticket) =>{
    return (dispatch) => {
        return Api.setEmail(ticket)
            .then(() => {
                // go to email login screen on next logout
                CookieManager.setEmailLogin("True");
                dispatch({ type: types.SET_EMAIL_SUCCEEDED, redirectLocation: UrlHelper.getProductSelectorUrl() });
            })
            .catch((error) => {
                dispatch({ type: types.SET_EMAIL_FAILED, error });
                throw(error);
            });
    };
};

export const validatePin = (pin, ticket) =>{
    return (dispatch) => {
        return Api.validatePin(pin, ticket)
            .then(() => {
                dispatch({ type: types.PIN_VALIDATED_SUCCEEDED, pin });
                return true;
            })
            .catch((error) => {
                dispatch({ type: types.PIN_VALIDATED_FAILED, error });
                return false;
            });
    };
};



